import { container } from 'inversify-props';
import {
  IApiService,
  IAuthService,
  ICenterService,
  IDoctorService,
  IDrugGroupService,
  IDrugService,
  IEventService,
  IPatientService,
  IUserService,
  IInvitationService,
  IStockService,
  IStatService,
} from '@/interfaces/Services'
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

import ApiService from '@/services/ApiService';
import AuthService from '@/services/AuthService';
import CenterService from '@/services/CenterService';
import DoctorService from '@/services/DoctorService';
import DrugGroupService from '@/services/DrugGroupService';
import DrugService from '@/services/DrugService';
import EventService from '@/services/EventService';
import InvitationService from '@/services/InvitationService';
import PatientService from '@/services/PatientService';
import StockService from '@/services/StockService';
import UserService from '@/services/UserService';
import StatService from '@/services/StatService';

export default function build(): void {
  container.bind<IApiService>(DependencyIdentifiers.ApiService).to(ApiService)
  container.bind<IAuthService>(DependencyIdentifiers.AuthService).to(AuthService)
  container.bind<ICenterService>(DependencyIdentifiers.CenterService).to(CenterService)
  container.bind<IDoctorService>(DependencyIdentifiers.DoctorService).to(DoctorService)
  container.bind<IDrugGroupService>(DependencyIdentifiers.DrugGroupService).to(DrugGroupService)
  container.bind<IDrugService>(DependencyIdentifiers.DrugService).to(DrugService)
  container.bind<IEventService>(DependencyIdentifiers.EventService).to(EventService)
  container.bind<IInvitationService>(DependencyIdentifiers.InvitationService).to(InvitationService)
  container.bind<IPatientService>(DependencyIdentifiers.PatientService).to(PatientService)
  container.bind<IStockService>(DependencyIdentifiers.StockService).to(StockService)
  container.bind<IUserService>(DependencyIdentifiers.UserService).to(UserService)
  container.bind<IStatService>(DependencyIdentifiers.StatService).to(StatService)
}